
import { defaultHtmlTable } from '../../services/constants';

export const getDefault = () => {
  const schema = {
    name: 'Tables',
    hasSectionTitle: false,
    isFullWidth: false,
    title: '',
    data: defaultHtmlTable,
  };
  return schema;
};
